import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {GroupeDeTravailDto} from '../model/groupe-de-travail.dto';

@Injectable({
	providedIn: 'root'
})
export class GroupeDeTravailService {

	private url = '/ws/groupes-de-travail';

	constructor(private http: HttpClient) {
	}

	/**
	 * Ajoute un groupe de travail pour un responsable donné.
	 *
	 * @param groupeDetravail Groupe de travail à ajouter.
	 * @returns Observable contenant la liste des groupes de travail mise à jour.
	 */
	ajouterGroupeDetravail(groupeDetravail: GroupeDeTravailDto): Observable<GroupeDeTravailDto[]> {
		return this.http.post<GroupeDeTravailDto[]>(this.url, groupeDetravail);
	}

	/**
	 *Recupére tous les groupes de travail pour un résponsable donnée.
	 *
	 * @param loginResponsable Login du responsable.
	 * @returns Observable contenant la liste des groupes de travail du responsable.
	 */
	recupererGroupesDeTravailParResponsable(loginResponsable: string): Observable<GroupeDeTravailDto[]> {
		return this.http.get<GroupeDeTravailDto[]>(`${this.url}`, {
			params: {loginResponsable}
		});
	}

	/**
	 * Supprime des groupes de travail spécifiés par leurs noms, pour un responsable donné.
	 *
	 * @param noms Liste des noms des groupes de travail à supprimer
	 * @param loginResponsable Login du responsable
	 * @returns Observable de la liste mise à jour des groupes de travail après suppression
	 */
	supprimerGroupesDeTravailParResponsable(noms: string[], loginResponsable: string): Observable<GroupeDeTravailDto[]> {
		const params = new HttpParams()
			.set('loginResponsable', loginResponsable)
			.set('noms', noms.join(','));
		return this.http.delete<GroupeDeTravailDto[]>(`${this.url}`, {params});
	}

	/**
	 * Modifie le nom de groupe de travail spécifié pour un responsable donné.
	 *
	 * @param nom Nom de groupe de travail.
	 * @param loginResponsable Login du responsable.
	 */

	mettreAJourNomGroupeDeTravail(param: { groupeDeTravailId: number, nom: string }): Observable<GroupeDeTravailDto> {
		const params = new HttpParams().set('use-case', 'modifier-nom-groupe-de-travail');

		return this.http.put<GroupeDeTravailDto>(`${this.url}/${param.groupeDeTravailId}`, param.nom, {params});
	}

	/**
	 * Ajoute un utilisateur à un groupe de travail
	 * @param groupeDeTravailId ID du groupe de travail
	 * @param loginUtilisateur Login de l'utilisateur à ajouter
	 * @returns Observable<GroupeDeTravailDto>
	 */
	public ajouterUtilisateur(groupeDeTravailId: number, loginUtilisateur: string): Observable<GroupeDeTravailDto> {
		const url = `${this.url}/${groupeDeTravailId}`;
		const params = new HttpParams().set('use-case', 'ajouter-utilisateur');
		return this.http.put<GroupeDeTravailDto>(url, loginUtilisateur, {params});
	}

	/**
	 * Retire des utilisateurs d'un groupe de travail.
	 * @param groupeDeTravailId ID du groupe de travail.
	 * @param logins Liste des logins des utilisateurs à retirer.
	 * @returns Observable<GroupeDeTravailDto> La liste des utilisateurs d'un groupe de travail mise à jour aprés suppresion.
	 */
	public retirerUtilisateur(groupeDeTravailId: number, logins: string[]): Observable<GroupeDeTravailDto> {
		const params = new HttpParams()
			.set('use-case', 'retirer-utilisateurs');
		return this.http.put<GroupeDeTravailDto>(`${this.url}/${groupeDeTravailId}`, logins, {
			params: params
		});
	}

	/**
	 * Met à jour les zones de travail autorisées du groupe de travail.
	 *
	 * @param groupeDeTravailId l'id du groupe de travail.
	 * @param zonesDeTravailIds les zones de travail autorisées pour le groupe de travail.
	 */
	modifierZoneDeTravailAutorisees(groupeDeTravailId: number, zonesDeTravailIds: number[]): Observable<void> {
		const params = new HttpParams()
			.set('use-case', 'modifier-zones-autorisees');
		return this.http.put<void>(`${this.url}/${groupeDeTravailId}`, zonesDeTravailIds, {params: params});
	}

	/**
	 * Récupère tous les groupes de travail selon le rôle de l'utilisateur.
	 *
	 * @param loginMembre le login de l'utilisateur.
	 */
	recupererGroupesDeTravailSelonRoleUtilisateur(loginMembre: string): Observable<GroupeDeTravailDto[]> {
		const params = new HttpParams()
			.set('loginMembre', loginMembre)
			.set('use-case', 'groupes-de-travail-selon-role-utilisateur');
		return this.http.get<GroupeDeTravailDto[]>(this.url, {params: params});
	}
}
